import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

// View mode
export const viewModeContainer: CSSProperties = {
  paddingTop: spacing.std,
  paddingBottom: spacing.std,
  marginRight: 8,
};

export const viewAllBtn = {
  style: {
    width: "100%",
    textAlign: "left",
    marginTop: spacing.sm,
  } as CSSProperties,
  labelStyle: {
    padding: "0 0 0 10px",
    textTransform: "unset",
    fontFamily: fontFamilySans,
    width: "calc(100% - 28px)",
    display: "inline-block",
    fontWeight: 400,
  } as CSSProperties,
};

// Edit mode
export const editModeContainer: CSSProperties = {
  height: "100%",
  width: "100%",
  position: "absolute",
  overflowY: "scroll",
  overflowX: "hidden",
  zIndex: 3,
  top: 0,
  left: 0,
  backgroundColor: greys.white,
  padding: `${spacing.sm}px 0 ${spacing.sm}px ${spacing.sm}px`,
};

export const closeIcon = {
  style: {
    right: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const header: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const searchContainer: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  marginTop: 10,
};

export const search: CSSProperties = {
  width: 20,
  height: 20,
};

export const title: CSSProperties = {
  color: colors.blueDusk.standard,
  fontWeight: "bold",
  fontSize: 20,
  marginTop: 0,
  marginLeft: 0,
  marginBottom: 0,
  marginRight: "auto",
};

export const businessIcon = {
  style: {
    marginRight: spacing.sm,
    marginTop: -3,
    width: 20,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const sectionHeader: CSSProperties = {
  marginBottom: spacing.std,
  color: colors.blueDusk.standard,
};

export const moreButton: CSSProperties = {
  marginTop: spacing.std,
};

export const buttonContainer: CSSProperties = {
  position: "fixed",
  bottom: 0,
  zIndex: 1,
  background: greys.white,
  marginLeft: -10,
  padding: `${spacing.std}px ${spacing.sm}px ${spacing.std}px ${spacing.sm}px`,
  boxShadow: "rgba(0, 0, 0, 0.25) 0px 0px 1px",
};
